import { gsap } from 'gsap/all'

export const lazyLoad = {
  init() {
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          gsap.set(entry.target, { opacity: 0 })
        } else {
          gsap.to(entry.target, {
            clearProps: 'all',
            duration: 0.5,
            opacity: 1,
            onComplete: () => {
              observer.unobserve(entry.target)
            },
          })
        }
      })
    }

    const imagesObserver = new IntersectionObserver(callback, { threshold: 0.15 })
    const images = document.querySelectorAll('img[loading=lazy]')

    images.forEach((image) => {
      imagesObserver.observe(image)
    })
  },
}
